import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Select, MenuItem, FormControl, InputLabel } from "@mui/material"

type FieldConfig = {
  name: string
  label: string
  type?: 'text' | 'textarea' | 'select' | 'number'
  placeholder?: string
  required?: boolean
  multiline?: boolean
  rows?: number
  options?: Array<{ label: string; value: string }>
}

type BordAddandEditDialogComponentProps = {
  openDialog: boolean
  handleCloseDialog: () => void
  addDialogLoading: boolean
  handleSubmit: () => void
  editData?: any
  formData: any
  setFormData: (data: any) => void
  fields?: FieldConfig[]
  title?: string
}

const BordAddandEditDialogComponent = ({
  openDialog,
  handleCloseDialog,
  addDialogLoading,
  handleSubmit,
  editData,
  formData,
  setFormData,
  fields,
  title
}: BordAddandEditDialogComponentProps) => {
  // Default fields if none provided
  const defaultFields: FieldConfig[] = [
    { name: 'name', label: 'Name', placeholder: 'Enter Name', required: true },
    { name: 'description', label: 'Description', placeholder: 'Enter Description', required: true, type: 'textarea', rows: 4 }
  ]

  const fieldsToRender = fields || defaultFields

  const handleFieldChange = (fieldName: string, value: any) => {
    setFormData({ ...formData, [fieldName]: value })
  }

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {title || (editData ? 'Edit' : 'Add New')}
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          {fieldsToRender.map((field) => {
            if (field.type === 'select') {
              return (
                <FormControl key={field.name} fullWidth>
                  <InputLabel>{field.label}</InputLabel>
                  <Select
                    label={field.label}
                    value={formData[field.name] || ''}
                    onChange={e => handleFieldChange(field.name, e.target.value)}
                    required={field.required}
                  >
                    {field.options?.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )
            }

            return (
              <TextField
                key={field.name}
                fullWidth
                label={field.label}
                type={field.type === 'number' ? 'number' : 'text'}
                value={formData[field.name] || ''}
                onChange={e => handleFieldChange(field.name, field.type === 'number' ? Number(e.target.value) : e.target.value)}
                required={field.required}
                placeholder={field.placeholder}
                multiline={field.type === 'textarea' || field.multiline}
                rows={field.rows || 1}
                inputProps={field.type === 'number' ? { step: '1' } : {}}
                autoComplete="off"
              />
            )
          })}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} disabled={addDialogLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={addDialogLoading}
          sx={{ bgcolor: '#5BC0BE', '&:hover': { bgcolor: '#49a9a7' } }}
        >
          {addDialogLoading ? 'Submitting...' : editData ? 'Update' : 'Submit'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default BordAddandEditDialogComponent
